import React from 'react';
import PropTypes from 'prop-types';
import Tag from '@nib/tag';
import {Columns, Column} from '@nib/layout';
import {tagValues, validTagValues} from '../common-prop-types';

export interface LabelWithTagProps {
  label: string;
  tag: tagValues;
}

const LabelWithTag: React.FC<LabelWithTagProps> = props => {
  const {label, tag} = props;
  return (
    <Columns space={4}>
      <Column>
        <span>{label}</span>
      </Column>
      <Column width="content">
        {tag && validTagValues.includes(tag) && (
          <Tag size="small" type="light">
            {tag.charAt(0).toUpperCase() + tag.slice(1)}
          </Tag>
        )}
      </Column>
    </Columns>
  );
};

LabelWithTag.displayName = 'LabelWithTag';

LabelWithTag.propTypes = {
  label: PropTypes.string.isRequired,
  tag: PropTypes.oneOf(validTagValues).isRequired
};

export default LabelWithTag;
